import request from '@/utils/request';
/* 列表 */
export function goodsCateList(data) {
  return request({
    url: '/goodsCategory/queryGoodsCategoryPageList',
    method: 'POST',
    data
  });
}
/* 增加 */
export function goodsCateAdd(data) {
  return request({
    url: '/goodsCategory/saveGoodsCategory',
    method: 'POST',
    data
  });
}
/* 修改 */
export function goodsCateEdit(data) {
  return request({
    url: '/goodsCategory/updateGoodsCategory',
    method: 'POST',
    data
  });
}
/* 修改中的信息展示 */
export function goodsCateInfo(data) {
  return request({
    url: '/goodsCategory/fetchGoodsCategoryDetailById',
    method: 'POST',
    data
  });
}
/* 删除 */
export function goodsCateDel(data) {
  return request({
    url: '/goodsCategory/removeGoodsCategoryById',
    method: 'POST',
    data
  });
}
/* 分类所有一级分类列表 */
export function goodsCateFirstParentList(data) {
  return request({
    url: '/goodsCategory/queryGoodsCategoryFirstParentList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/goodsCate.js